import customrouter from '@uptogether/auth-spa-vue-components/middlewareRouting'
import localstorage from '@/utils/localstorage'
export default (context) => {
  // Getting the PayPal authCode from url param and storing it in localStorage for acocunt creation
  const params = new URLSearchParams(window.location.search)
  if (params.has('option') && params.has('code') && !params.has('tab')) {
    const code = params.get('code')
    localstorage.set('applicationAuthCode', code)
  }

  /*
   * For info on how to use the properties below, see:
   * https://github.com/fii-org/shared.web.vue.components/blob/master/components/AuthSpa/middlewareRouting.js
   * If a relationship is not created on entity creation, a member will not be redirected to the landing page
   */
  const redirectPaths = [
    { path: '/fund', redirect: '/cookie__preferred-partner' },
    { path: '/fund/', redirect: '/cookie__preferred-partner' },
    { path: '/es/fund', redirect: '/cookie__preferred-partner' },
    { path: '/es/fund/', redirect: '/cookie__preferred-partner' },
  ]
  const authNotRequiredRegexArray = [
    '^error.+',
    '^temporarily-down.+',
    'fund___..$',
    'fund-slug___..$',
  ]
  const permissions = [
    {
      resolvedRoute: 'all', // special case.  All routes will require this.
      requiredPermission: 'app_landing',
    },
    {
      resolvedRoute: 'surveys',
      requiredPermission: 'app_surveys',
      redirect: '/',
    },
    {
      resolvedRoute: 'groups',
      requiredPermission: 'app_social',
      redirect: '/',
    },
    {
      resolvedRoute: 'financials',
      requiredPermission: 'app_financials',
      redirect: '/',
    },
    {
      resolvedRoute: 'fund',
      requiredPermission: 'app_relief',
      redirect: '/',
    },
  ]

  return customrouter(
    context,
    redirectPaths,
    authNotRequiredRegexArray,
    permissions
  )
}
